export type NewRheologyPageParams = Readonly<Record<'entityId', string | undefined>>;

export const ROUTE_PARAM_IDENTIFIER = ':entityId';
export const ROUTE_PATH = `/admin/projects/${ROUTE_PARAM_IDENTIFIER}/rheology/new`;
export const TITLE = 'New Rheology Data';
